
import Hero from "@/components/Hero";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Topics from "@/components/trainings/Topics";
import ExtendedTopics from "@/components/trainings/ExtendedTopics";
import TrainingFormat from "@/components/trainings/TrainingFormat";
import Testimonials from "@/components/trainings/Testimonials";

const Trainings = () => {
  return (
    <div className="fade-in">
      <Hero 
        title="Koolitused ja Meeskonnacoaching"
        subtitle="Vastupidavad, ühtehoidvad meeskonnad läbi trauma teadlikkuse ja positiivse psühholoogia."
        bgColor="bg-gradient-to-r from-kaija-sage to-kaija-light"
      />
      
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <p className="text-gray-700 mb-10 text-lg leading-relaxed">
              Kaija Alliksaare koolitused ja meeskonnacoaching keskenduvad töötajate vastupidavuse, tööheaolu ja meeskonnatöö tugevdamisele. Koolitused pakuvad praktilisi tööriistu, mis aitavad luua toetavat ja ühtset meeskonda, suurendades teineteise mõistmist ja koostööd. Koolitused on arendavad nii juhtidele kui meeskonnaliikmetele, suurendades teineteise mõistmist ja paremat koostööd.
            </p>
            
            <h2 className="text-2xl font-medium mb-8 text-center">Koolituste põhiteemad</h2>
            
            <Topics />
            
            <div className="my-16 flex justify-center">
              <img 
                src="/images/Capture41.jpg" 
                alt="Koolitused" 
                className="rounded-lg shadow-md w-full max-w-2xl hover:shadow-lg transition-shadow duration-300"
              />
            </div>
            
            <ExtendedTopics />
            <TrainingFormat />
            
            <h2 className="text-2xl font-medium mb-8 text-center">Osalejate tagasiside</h2>
            <Testimonials />
            
            <div className="flex justify-center">
              <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white px-8 py-6 text-lg">
                <Link to="/contact">Võta ühendust</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-kaija-light to-kaija-sage text-center">
        <div className="container-custom">
          <h2 className="text-3xl font-medium mb-6">Alusta enda teekonda</h2>
          <p className="text-gray-700 mb-8 max-w-2xl mx-auto text-lg">
            Võta täna ühendust ja sisene transformatsiooni ja isikliku arengu maailma. Alusta muutust.
          </p>
          <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white px-8 py-6 text-lg">
            <Link to="/contact">Võta ühendust</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Trainings;
